module.exports = __webpack_public_path__ + "static/media/male-condom-green.fd609a37.svg";